export default __webpack_public_path__ + "static/media/largPdfIcon.58665547.png";